/** Inline error with a Retry — replaces dead-end red boxes on failed queries. */
export function QueryError({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <div className="kd-error" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
      <span style={{ minWidth: 0 }}>{message}</span>
      <button type="button" className="kd-retry" onClick={onRetry}>
        Retry
      </button>
    </div>
  );
}
